module.exports = __webpack_public_path__ + "img/logo.a872e50b.png";